// extracted by mini-css-extract-plugin
export var area = "styles-module--area--b7652";
export var chat = "styles-module--chat--bd579";
export var scroll = "styles-module--scroll--3d1e9";